<template>
    <article v-if="mailing">
        <form-mailing :edit="mailing"></form-mailing>
    </article>
</template>

<script>
import { ref } from "vue";
import {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
} from "@headlessui/vue";
import { CheckIcon, PencilAltIcon } from "@heroicons/vue/outline";

export default {
    components: {
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        CheckIcon,
        PencilAltIcon,
    },
    mounted() {
        this.getNewsletter("get");
        Eventing.listen("closeModal", () => (this.open = false));

        Eventing.listen("noWarning", () => (this.warning = false));
        Eventing.listen("warning", () => (this.warning = true));

        Eventing.listen("loadAttachments", () =>
            this.getNewsletter("documents")
        );
    },
    created() {},
    data() {
        const open = ref(false);

        return {
            open,
            mailing: null,
            logo: null,
            warning: false,
        };
    },
    methods: {
        getNewsletter(_action) {
            var self = this;
            axios
                .get(
                    "/api/modules/newsletters/" +
                        self.$route.params.id +
                        "?edit=true"
                )
                .then((response) => {
                    if (_action == "documents") {
                        Eventing.fire(
                            "reloadAttachments",
                            response.data.data.documents
                        );
                    } else {
                        this.mailing = response.data.data;
                    }
                    this.open = true;
                })
                .catch((error) => {
                    // alert(error.response.status);
                });
        },
    },
};
</script>
